// src/redux/services/store/storeCategoryPagesApi.ts
import type { EndpointBuilder } from "@reduxjs/toolkit/query";
import { baseApi } from "../baseApi";

export type StoreSectionItem = {
  id: number;
  section_id: number;
  slot: string | null;
  sort_order: number;
  is_active: boolean;
  content_json: Record<string, any>;
  created_at?: string;
  updated_at?: string;
};

export type StoreSection = {
  id: number;
  page_slug: string;
  section_type: string;
  title?: string | null;
  sort_order: number;
  is_active: boolean;
  settings_json?: Record<string, any> | null;
  data_source_json?: Record<string, any> | null;
  created_at?: string;
  updated_at?: string;
  items?: StoreSectionItem[];
};

export type CategoryPageCategory = {
  id: number;
  parent_id?: number | null;
  name: string;
  slug: string;
  description?: string | null;
  image_url?: string | null;
  banner_url?: string | null;
  seo_title?: string | null;
  seo_description?: string | null;
  is_active: boolean;
  sort_order: number;
};

export type CategoryPageMeta = {
  id: number;
  page_slug: string;
  title?: string | null;
  seo_json?: Record<string, any> | null;
  meta_json?: Record<string, any> | null;
};

export type StoreCategoryPageResponse = {
  category: CategoryPageCategory;
  page?: CategoryPageMeta | null;
  sections: StoreSection[];
};

type Builder = EndpointBuilder<any, any, any>;

export const storeCategoryPagesApi = baseApi.injectEndpoints({
  endpoints: (builder: Builder) => ({
    getStoreCategoryPage: builder.query<
      StoreCategoryPageResponse,
      { categorySlug: string; includeItems?: boolean; activeOnly?: boolean; sectionType?: string }
    >({
      query: ({ categorySlug, includeItems = true, activeOnly = true, sectionType }) => ({
        url: `/store/category-page/${encodeURIComponent(categorySlug)}`,
        params: {
          include_items: includeItems,
          active_only: activeOnly,
          ...(sectionType ? { section_type: sectionType } : {}),
        },
        method: "GET",
      }),
      providesTags: (_result: StoreCategoryPageResponse | undefined, _err: unknown, arg) => [
        { type: "StorePage", id: `category:${arg.categorySlug}` },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetStoreCategoryPageQuery } = storeCategoryPagesApi;